import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { templateData } from '../data/templateData';
import './checkin.css';
import { useAuth } from '../hooks/useAuth';
// import ProfessionalChatbot from '../components/ProfessionalChatbot';
import QuestionManager from "../components/QuestionManager"

import  PatientsInformation from "../adhoc/components/PatientsInformation"
import CallCase from '../components/CallCase';
import Alert from "../components/Alert";

const PatientMonitoringCheckIn = () => {
  const { id } = useParams();
  const [adhoc, setAdhoc] = useState(false);
  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user, logout } = useAuth();
  const [promptPlaceholders, setPromptPlaceholders] = useState([]);
  const [patients, setPatients] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const API_URL = process.env.NODE_ENV === 'development' ? "https://demo.aiguardian.io/agent-backend": "/agent-backend";
  const PROMPT = `task: "Appointment Reminder"
category: "Appointment Reminder"
appointment_date: "<APPOINTMENT_DATE>"
appointment_time: "<APPOINTMENT_TIME>"
location: "<LOCATION>"
instructions:
- "Confirm the patient's name at the start of the call."
- "Remind them of their appointment on <APPOINTMENT_DATE> at <APPOINTMENT_TIME>."
- "Inform them the appointment is at <LOCATION>."
- "Ask if they have any questions or need to reschedule. If they need to reschedule, they can do so on the HealthHub app."`;

    useEffect(() => {
    // Simulate API call
    console.log(id)

    setTimeout(() => {
      if (id === "Adhoc Task")
        setAdhoc(true)
      
      const foundtemplate = templateData.find(template => template.service === id);
      if (foundtemplate) {
        setTemplate(foundtemplate);
      } else {
        setError('assistant not found');
      }
      setLoading(false);
    }, 100);

  }, [id]);
  
  if (loading) {
    return <div>Loading details...</div>;
  }

  const handleSelectedItemsChange = (items) => {
    setSelectedItems(items);
  };

  const triggerAlert = (msg) => {
    setAlertMessage(msg);
    setShowAlert(true);
  };

  const handleCallSelectedPatients = async (patients, placeholders) => {
    const tasks = patients
    .filter(patient => patient.selected)
    .map(patient => {
      if (selectedItems.length>10){

        alert("the number of selected questions is greater than 10")
        return
      }
      console.log(selectedItems.length)

      //patient["question_array"] = [[0,0,1,1,0],[1,1,0,0,0]]
      const groupedByType = selectedItems.reduce((acc, item) => {
        if (!acc[item.name]) {
          acc[item.name] = [];
        }
        acc[item.name].push(item.text);
        return acc;
      }, {});

      patient["question_list"] = groupedByType //["Mobility","Pain Assessment"]
      patient["type"] = "auto check-in"
      

      if ( Object.keys(groupedByType).length == 0){
        //alert("Please select at least one abnormal option")
        triggerAlert("Please select at least one question.")
        return 
      }
      
      fetch(API_URL+'/api/createjob', {
        method: "POST",
        headers: { "Content-Type": "application/json","Authorization": "Bearer "+user.token },
        body: JSON.stringify(patient)
      }).then( response => {
        if (response.status === 200)
          //alert("You have successfully created a new call.")
          triggerAlert("You have successfully created a new call.")
        else
          //alert("An error occurred while creating the call.")
          triggerAlert("An error occurred while creating the call.")
       }
      )

      //patient["selectedItems"] = selectedItems
      console.log(patient)
    })

  }
  const handleSubmit = (e) => {
    e.preventDefault();

    console.log("submit",e.target.name.value,e.target.phone.value)
    let checklist = template.agenda.checklist ?  (template.agenda.checklist).join("\n") : "";
    if (e.target.checklist)
      checklist = e.target.checklist.value
    console.log("checklist",checklist)
    const newTask = {
      "type":  "ad-hoc",
      "name": e.target.name.value,
      "phone_number": e.target.phone.value,
      "prompt":checklist,      
    }
    if (e.target.time.value){
      newTask["call_at"] = e.target.time.value
    }
    fetch(API_URL+'/api/createjob', {
      method: "POST",
      headers: { "Content-Type": "application/json","Authorization": "Bearer "+user.token },
      body: JSON.stringify(newTask)
    }).then( response => {
      if (response.status === 200)
        alert("You have successfully created a new call.")
      else
        alert("An error occurred while creating the call.")
     }
    )
  }
  
  return (
    <div className="container">
      {/* Header 
      <div className="header-1">
        <button className="back-button">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z" clipRule="evenodd" />
          </svg>
          Back to Roles
        </button>
      </div>
      */}
      {/* Main Content */}
      <div className="main-content-1">
        {/* Left Column - Profile */}
        <div className="profile-column">
          <div className="profile-image-container">
            <img 
              src={template.photo}
              alt="Healthcare professional" 
              className="profile-image"
            />
           
          </div>
          
          <div className="profile-info">
            <h2 className="profile-name">{template.name}</h2>
            <h3 className="profile-role">{template.service}</h3>
            <p className="profile-description">
               {template.introduction}
            </p>
          </div>
        </div>

        {/* Right Column - Details */}
        <div className="details-column">
          <h1 className="page-title">Patient Contact Information</h1>
          
  
          
          {/* Action Buttons */}
          <div className="action-buttons">           
          
              { adhoc === true && 
                  <div className="agenda-section">
                    <h2 className="section-title">Checklist</h2>                  
                    
                    <textarea 
                      type="text"
                      cols="40"
                      rows="10"
                      id="checklist"
                      name="checklist"
                      className="form-control"
                      defaultValue={PROMPT}
                    />
                      {/* <ProfessionalChatbot/> */}
                    
                  </div>

              }
            <div> <CallCase onSelectedItemsChange={handleSelectedItemsChange} /> </div>
            <div className="agenda-container">
            <PatientsInformation 
              patients={patients}
              setPatients={setPatients}
              placeholders={promptPlaceholders}
              handleCallSelectedPatients={handleCallSelectedPatients}
            />
            
            </div>
            
            
          </div> 
          {/* Agenda Section */}
          {/* <div className="agenda-section">
            <h2 className="section-title">Agenda</h2>
            
            <div className="agenda-container">
              <h3 className="agenda-title">{template.agenda ? template.agenda["title"]: ""}</h3>
              <p className="agenda-description">
                {template.agenda ? template.agenda["descipt"]: ""}
              </p>
              { adhoc === true && template.agenda && template.agenda.checklist && <div>
              <h3 className="checklist-title">Checklist</h3>
              <ul className="checklist">

              { template.agenda.checklist.map((item,index) => (
                <li className="checklist-item" key={index}>
                  <svg className="check-icon" width="20" height="20" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                  </svg>
                  <span>{item}</span>
                </li>               
               )
              )
              };
                
              </ul> </div>
               }
            </div>            
          </div> */}
        </div>
      </div>

      <Alert
              show={showAlert}
              onClose={() => setShowAlert(false)}
              message={alertMessage}
            />
            
    </div>
  );
};

export default PatientMonitoringCheckIn;